import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { ModalsManager } from '@/components/modals/modalsManager';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { trackEvent } from '@/utils/analytics';
import { handleExternalUrlClick } from '@/utils/platform';

import { changelogSeenStore } from './changelog-seen.store';
import { CHANGELOG_URL } from './changelog.feed';
import {
  useChangelogFeedQuery,
  useUnseenChangelogEntry,
} from './changelog.query';
import { ChangelogEntryModal } from './ChangelogEntryModal';

export const ChangelogMenuItem = observer(() => {
  const { data: entries } = useChangelogFeedQuery();
  const latestEntry = entries?.[0];
  const unseenEntry = useUnseenChangelogEntry();

  return (
    <DropdownMenu.Item
      className="gap-2"
      onClick={() => {
        trackEvent('CHANGELOG_MENU_CLICKED');
        changelogSeenStore.markOpened(unseenEntry?.id);
        if (latestEntry) {
          ModalsManager.show(
            ChangelogEntryModal,
            { entry: latestEntry },
            { unique: true }
          );
        } else {
          handleExternalUrlClick(CHANGELOG_URL);
        }
      }}
    >
      <Icons.megaphone className="text-foreground-subtle" />
      <span className="flex-1">What's new</span>
      {unseenEntry ? (
        <span aria-hidden className="size-1.5 rounded-full bg-shell-accent" />
      ) : null}
    </DropdownMenu.Item>
  );
});
